import {set} from 'lodash';

export default class FieldPairsValidation {
  constructor() {
    this.pairsList = {};
    this.pairsExists = false;
    this.inited = false;
    this.init = this.init.bind(this);
    this.checkPairValidity = this.checkPairValidity.bind(this);
  }

  init() {
    if (this.inited) {
      return;
    }

    const allInputs = Array.prototype.slice.call(document.querySelectorAll('input'));
    allInputs.map((input) => {
      if (input.getAttribute('pairname')) {
        this.checkPairValidity(input);
      }
    });
    this.inited = true;
    return this;
  }

  addNewPair(pairName) {
    this.pairsList = {
      ...this.pairsList,
      [pairName]: { fields: {}, validated: false }
    }
  }

  addNewPairField(pairName, inputName, inputValue) {
    this.pairsList.fields = {
      ...this.pairsList.fields,
      [inputName]: inputValue.length > 0
    }
  }



  checkPairValidity(input, init = false) {
    const pairName = input.getAttribute('pairname');
    const inputName = input.getAttribute('name');
    const inputValue = input.value;

    if (init && Object.keys(this.pairsList).length === 0) {
      this.init();
    }

    if (!Object.keys(this.pairsList).find(key => key === pairName)) {
      this.addNewPair(pairName);
    }

    if (!Object.keys(this.pairsList).find(key => key === inputName)) {
      this.addNewPairField(pairName, inputName, inputValue);
    }

    set(this.pairsList, [pairName, 'fields', inputName], inputValue.length > 0);
    set(
      this.pairsList, [pairName, 'validated'],
      Object.keys(this.pairsList[pairName].fields).find(key => this.pairsList[pairName].fields === false) === undefined
    )

    this.pairsExists = Object.keys(this.pairsList).find(key => this.pairsList[key].validated === true) !== undefined;
  }
}
